import { render, staticRenderFns } from "./teacher-personal-data.vue?vue&type=template&id=20637d51&"
import script from "./teacher-personal-data.vue?vue&type=script&lang=js&"
export * from "./teacher-personal-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports